var $9867160d996455a0$exports = {};
$9867160d996455a0$exports = {
  "close": "Aizv\u0113rt",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " pazi\u0146ojums");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " pazi\u0146ojumi");
      }
    }), ".");
  }
};
export { $9867160d996455a0$exports as default };